import Table from "../../../common/table/Table";

const USER_ORDERS_HEADER = ['First Name', 'Last Name', 'Dish', 'Options', 'Additional info'];
const USER_ORDER_FIELDS = ['firstName', 'lastName', 'dishName', 'selectedOptions', 'additionalInfo'];

const UserOrdersTable = ({orders, onEditOrder, onRemoveOrder}) => {
    const formatOrder = (order) => {
        const {dish} = order;
        if (!dish) {
            return order;
        }
        const {options, name: dishName} = dish;
        const selectedOptions = options ? options.map(({value}) => value).join(', ') : [];
        return ({
            ...order,
            dishName,
            selectedOptions
        });
    }
    const tableOrders = orders.map(formatOrder);
    return (
        <Table
            header={USER_ORDERS_HEADER}
            fields={USER_ORDER_FIELDS}
            items={tableOrders}
            onEditRowClick={onEditOrder}
            onDeleteRowClick={onRemoveOrder}
            editable
        />
    );
}

export default UserOrdersTable;
